import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';
import { useU2000AuthContext } from '../../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000FormStateHandlersReturn } from '../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import { U2000FormStateEnumState } from '../../../../u2000Core/reducer/formReducer/U2000FormState';
import { NS, U3153ROLES } from '../../../U3153';
import { u3153IsSystemInvoiceTypeCode, type U3153InvoiceTypeFormRow } from '../../../U3153Service';

export type U3153InvoiceTypeFormToolbarHandlers = U2000FormStateHandlersReturn<U3153InvoiceTypeFormRow> & {
  addNewInvoiceType: () => void;
  modifyInvoiceType: () => void;
  deleteInvoiceType: () => void | Promise<void>;
};

interface U3153InvoiceTypeFormToolBarProps {
  formStateHandlers: U3153InvoiceTypeFormToolbarHandlers;
}

export const U3153InvoiceTypeFormToolBar: React.FC<U3153InvoiceTypeFormToolBarProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();
  const data = formStateHandlers.getData();
  const deleteDisabled =
    formState === U2000FormStateEnumState.EDIT || u3153IsSystemInvoiceTypeCode(data?.code);

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3153ROLES.ADD),
      handleClick: () => {
        formStateHandlers.addNewInvoiceType();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3153ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyInvoiceType();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3153ROLES.DELETE),
      handleClick: () => {
        formStateHandlers.deleteInvoiceType();
      },
      disabled: deleteDisabled,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
